/**
 * This is the same as ParcelHistory, except ParcelID property,
 * is replaced by ParcelIDs
 */
export class ParcelHistories {
  [x: string]: any;
  ParcelIDs: number[] = [];
  ManifestID: string;
  ProcessedDate: String;
  TPSL: number;
  Contact: string;
  ExceptionID: number;
  SubExceptionID: number;
  Reason: string;
  VisitCode: number;
  ShippingType: number;
  SourceType: number;
  DepotID: number;
  Height: number;
  Width: number;
  Length: number;
  Weight: number;
  Cubing: number;
  CustomerID: number;
  ChuteID: number;
  NCV: number;
  FloorID: number;
  UserID: number;
  PostponedDate: string;
  SourceID: number;
}
